// react
import React from 'react';
import FooterContacts from './FooterContacts';
import FooterLayanan from './FooterLayanan';
import FooterPembayaran from './FooterPembayaran';
import ToTop from './ToTop';

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <div className="container">
                <div className="site-footer__widgets">
                    <div className="row footer-row">
                        {/* Kolom 1: Brand & Alamat (Mobile: 12, Tablet: 6, Desktop: 5) */}
                        <div className="col-12 col-md-6 col-lg-5 footer-col footer-col--brand mb-4 mb-lg-0">
                            <FooterContacts />
                        </div>

                        {/* Kolom 2: Hubungi Kami (Mobile: 12, Tablet: 6, Desktop: 3) */}
                        <div className="col-12 col-md-6 col-lg-3 footer-col footer-col--contact mb-4 mb-lg-0">
                            <FooterLayanan />
                        </div>

                        {/* Kolom 3: Pembayaran & Sosmed (Mobile: 12, Tablet: 12, Desktop: 4) */}
                        <div className="col-12 col-md-12 col-lg-4 footer-col footer-col--payment">
                            <FooterPembayaran />
                        </div>
                    </div>
                </div>

                {/* Bottom Bar: Simple Copyright */}
                <div className="site-footer__bottom">
                    <p className="site-footer__copyright">
                        © {currentYear}{' '}
                        <a href="https://hokkysumbermakmur.com" rel="noopener noreferrer" target="_blank">
                            HOKKY BANGUNAN
                        </a>{' '}
                        (PT. Hokky Sumber Makmur). All Rights Reserved.
                    </p>
                </div>
            </div>
            <ToTop />
        </footer>
    );
}
